import React, { useState } from "react"
import webify from "../util/webify"
import chevronLeftSVG from "../../../priv/static/svg/generic/chevron-left.svg"
import chevronRightSVG from "../../../priv/static/svg/generic/chevron-right.svg"
import SVG from "react-inlinesvg"

interface ChevronToggleProps {
  pointing: "left" | "right"
  isOpen?: boolean
  toggle?: string
}

const ChevronToggle = (props: ChevronToggleProps) => {
  let { pointing, toggle, isOpen = false } = props
  let [open, setOpen] = useState(!!isOpen)
  let chevronSVG = pointing == "left" ? chevronLeftSVG : chevronRightSVG
  let rotatedClass = ""

  if (pointing == "right" && open) {
    rotatedClass = "rotated-clockwise"
  } else if (pointing == "left" && open) {
    rotatedClass = "rotated-counter-clockwise"
  }

  return (
    <div
      className={`chevron-toggle-component svg-icon hover:cursor-pointer ${rotatedClass}`}
      onClick={() => {
        document.querySelector(toggle).classList.toggle("js-hidden")
        setOpen(!open)
      }}
    >
      <SVG src={chevronSVG} className="inline" />
    </div>
  )
}

export default ChevronToggle
webify("chevron-toggle", ChevronToggle)
